import MarkdownComponent from 'markdown-to-jsx'
import { useMemo, memo } from 'react'

import styles from './Markdown.module.css'
import { CustomLink } from '../customLink'

const createOverrides = (analyticsHandlers) => ({
  h1: {
    component: 'h1',
    props: {
      className: styles.styledH1
    }
  },
  h2: {
    component: 'h2',
    props: {
      className: styles.styledH2
    }
  },
  h3: {
    component: 'h3',
    props: {
      className: styles.styledH3
    }
  },
  ul: {
    component: 'ul',
    props: {
      className: `${styles.styledList} ${styles.styledUnorderedList}`
    }
  },
  ol: {
    component: 'ol',
    props: {
      className: `${styles.styledList} ${styles.styledOrderedList}`
    }
  },
  li: {
    component: 'li',
    props: {
      className: styles.styledListItem
    }
  },
  span: {
    component: 'span',
    props: {
      className: styles.styledSpan
    }
  },
  a: {
    component: (linkProps) => <CustomLink {...linkProps} analyticsHandlers={analyticsHandlers} />
  },
  hr: {
    component: 'hr',
    props: {
      className: styles.styledHr
    }
  }
})

export const Markdown = memo(({ analyticsHandlers, ...props }) => {
  const overrides = useMemo(
    () => createOverrides(analyticsHandlers),
    [analyticsHandlers]
  )

  return (
    <MarkdownComponent
      {...props}
      className={styles.markdownContainer}
      options={{
        wrapper: 'div',
        overrides
      }}
    />
  )
})
